import { render, staticRenderFns } from "./ChallengesList.vue?vue&type=template&id=2d6186e2&scoped=true"
import script from "./ChallengesList.vue?vue&type=script&lang=js"
export * from "./ChallengesList.vue?vue&type=script&lang=js"
import style0 from "./ChallengesList.vue?vue&type=style&index=0&id=2d6186e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6186e2",
  null
  
)

export default component.exports